import { Navigate, useLocation } from 'react-router-dom';

import { handleLogin } from '../../services/apiClient';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  const location = useLocation();

  const route_to = "/";

  if (!isAuthenticated) {
    // Перенаправляем на страницу логина, сохраняя текущий путь
    return <Navigate to={route_to} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;